module.exports = __webpack_public_path__ + "static/media/podme_background.bdb0d5a0.png";